import { DatePicker, Form, Row, Col, Select, InputNumber, message } from "antd"
import { useTranslation } from "react-i18next"
import {
    FileTextOutlined,
    IdcardOutlined,
} from '@ant-design/icons';
import useExpenseTypes from "hooks/useExpenseTypes";
import { useEffect } from "react";
const { Option } = Select;
export default function EmployeeForm({ form, onSubmit }) {
    const { t } = useTranslation()
    const { Expenses, getAllExpenseTypes, setExpenseTypes, isLoading, error, setError } = useExpenseTypes();
    useEffect(() => {
        setError(null);
        getAllExpenseTypes();
        if (error) {
            message.error(error);
        }
    }, [form])

    return (
        <Form
            layout="vertical"
            name="expense_form"
            id="expense_form"
            form={form}
            onFinish={onSubmit}
            style={{
                maxWidth: 600,
                margin: "0 auto",
                marginTop: "30px"
            }}
        >
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.Item
                        label={t("expenses.crud.form.label.creationDate")}
                        name="creationDate"
                        rules={[
                            {
                                required: true,
                                message: t("expenses.crud.form.error.label.required.creationDate"),
                            },
                        ]}
                    >
                        <DatePicker prefix={<FileTextOutlined style={{ color: "#f3db56" }} />} style={{ width: "100%" }} allowClear className="custom-input" />
                    </Form.Item>
                </Col>

            </Row>
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.Item
                        label={t("expenses.crud.form.label.price")}
                        name="price"
                        rules={[
                            { required: true, message: t("expenses.crud.form.error.label.required.price") },
                        ]}
                    >
                        <InputNumber prefix={<IdcardOutlined style={{ color: "#f3db56" }} />} style={{ width: '100%' }} className='custom-input' />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col xs={24} md={24}>
                    <Form.Item
                        label={t("expenses.crud.form.label.expenseTypeId")}
                        name="expenseTypeId"
                        rules={[{ required: true, message: t("expenses.crud.form.error.label.required.expenseTypeId") }]}
                    >
                        <Select placeholder={t("expenses.crud.form.placeholder.expenseTypeId")} className='custom-input' loading={isLoading} >
                            {Expenses && Expenses.map((expense) => (
                                <Option key={expense.id} value={expense.id}>{t(expense.type)}</Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Col>
            </Row>

        </Form >
    )
}
